import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { SystemSettingsProvider } from './context/SystemSettingsContext';
import { AlarmNotificationProvider } from './context/AlarmNotificationContext';
import reportWebVitals from './reportWebVitals';

// 전시회 데모 모드: 인증 우회 - 기본 토큰/유저 자동 주입
if (!localStorage.getItem('token')) {
  localStorage.setItem('token', 'expo-demo-token');
  localStorage.setItem('user', JSON.stringify({
    id: 1,
    username: 'expo',
    name: '전시회 데모',
    role: 'SUPER_ADMIN',
    schemaName: 'demo',
    permissions: [
      'machine.view',
      'factory_monitoring.view',
      'enterprise.view',
      'ai.view',
      'factory.view',
      'equipment.view',
      'user.view',
      'role.view',
      'notice.view',
      'system.view',
      'platform.view',
    ],
  }));
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <SystemSettingsProvider>
      <AlarmNotificationProvider>
        <App />
      </AlarmNotificationProvider>
    </SystemSettingsProvider>
  </BrowserRouter>
);

reportWebVitals();
